import DateTimeModal, {CURRENT_TIME} from './DateTimeModal';

export default DateTimeModal;
export {CURRENT_TIME};



// WEBPACK FOOTER //
// ./src/ondemand/components/DateTimeModal/index.js